import Vue from 'vue';
import { BG_EXCHANGE_RATE } from '../consts/bg-exchange-rate';
import { formatAsPrice } from '../utils';

Vue.component('configurator-offer-step', {
    props: {
        siteHandle: {
            type: String,
        },
    },

    data() {
        return {
            data: null,
        };
    },

    async mounted() {
        EventBus.$on('configurator-offer-step', (data) => {
            this.data = data;
        });
    },

    destroyed() {},

    watch: {},

    methods: {
        parseTransformedImage(image) {
            return JSON.parse(image);
        },

        formatPriceInBg(price) {
            const priceInNumbers = parseFloat(
                String(price).replace(' ', '').replace('.', ''),
            );
            const priceInBg = priceInNumbers * BG_EXCHANGE_RATE;
            return formatAsPrice(priceInBg);
        },

        closeSummaryScreen() {
            this.data = null;
            EventBus.$emit('close-summary-screen');
        },

        getCalculatedPriceWithCopy(currency, data) {
            const price = data;
            if (currency.includes('{price}')) {
                return currency.replace('{price}', price);
            }
            return this.siteHandle === 'mgMotorsBulgaria'
                ? `${currency} ${price} / ${this.formatPriceInBg(price)} лв`
                : `${currency} ${price}`;
        },

        getFormattedOfferStepPrice(currency, prices, financeHandle) {
            const priceText = prices[financeHandle];

            const formattedPrice =
                this.siteHandle === 'mgMotorsIreland'
                    ? parseFloat(priceText.replace(/\./g, '')).toLocaleString(
                          'en-IE',
                          { maximumFractionDigits: 0 },
                      )
                    : priceText.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
            return this.getCalculatedPriceWithCopy(currency, formattedPrice);
        },

        isConfigurationOptionPriceDisplayed(data, financeHandle) {
            return data && Number(data.prices[financeHandle]);
        },

        getActivePromotionsForOffer() {
            const hasRequiredData =
                this.data &&
                this.data.edition &&
                this.data.edition.promotions &&
                this.data.selectedPromotionKeys;

            if (!hasRequiredData) {
                return [];
            }

            return this.data.edition.promotions.filter(
                (p) =>
                    p.financingHandle === this.data.finance.financingHandle &&
                    this.data.selectedPromotionKeys.includes(
                        p.financingHandle + '::' + p.promotionTitle,
                    ),
            );
        },

        parseFormattedPrice(price) {
            const str = price.toString();
            // IE uses comma as thousands separator and dot as decimal (e.g. "69,900").
            if (this.siteHandle === 'mgMotorsIreland') {
                return parseFloat(str.replace(/,/g, ''));
            }
            return parseFloat(str.replace(/\./g, '').replace(',', '.'));
        },

        getDiscountedTotalPrice() {
            if (!this.data || !this.data.totalPrice) return '';
            const rawTotal = this.parseFormattedPrice(this.data.totalPrice);
            const activePromotions = this.getActivePromotionsForOffer();
            const totalDiscount = activePromotions.reduce(
                (sum, p) => sum + Number(p.discount),
                0,
            );
            const discountedTotal = rawTotal + totalDiscount;
            const formatted =
                this.siteHandle === 'mgMotorsIreland'
                    ? discountedTotal.toLocaleString('en-IE', {
                          maximumFractionDigits: 0,
                      })
                    : discountedTotal
                          .toString()
                          .replace(/\B(?=(\d{3})+(?!\d))/g, '.');
            return this.getCalculatedPriceWithCopy(
                this.data.generalTranslations.currency,
                formatted,
            );
        },

        formatPromotionDiscount(discount, currency) {
            if (!discount) return '';
            let abs;
            if (this.siteHandle === 'mgMotorsIreland') {
                abs = Math.abs(discount).toLocaleString('en-IE', {
                    maximumFractionDigits: 0,
                });
            } else {
                abs = Math.abs(discount)
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, '.');
            }
            const sign = discount < 0 ? '-' : '+';
            if (currency.includes('{price}')) {
                return currency.replace('{price}', sign + abs);
            }
            return `${currency} ${sign}${abs}`;
        },
    },
});
